import { tab } from "@testing-library/user-event/dist/tab";
import { createLogicalAnd } from "typescript";

const getTimeInMilliSeconds = (a:any) => {
    let timeArr = a.split(':');
    if(timeArr[0] === "00" && timeArr[1] === "00") {
        let milliSeconds = ((23 * 60 * 60) + (59 * 60) + 59) * 1000;
        return milliSeconds;
    }
    let milliSeconds = ((+timeArr[0]) * 60 * 60 + (+timeArr[1]) * 60) * 1000; 
    return milliSeconds;
};

const extractToFromTimes = (obj:any) => ({ toTime: new Date(obj.endTime).getTime(), fromTime: new Date(obj.startTime).getTime() });


const getOverlap = (a:any, b:any) => {
    return Math.max(0, Math.min(a.toTime, b.toTime) - Math.max(a.fromTime, b.fromTime));
};

const getIsMinuteZero = (obj:any) => {

    const { fromTime, toTime } = obj;
    
    if(fromTime.split(":")[1] === "00" && toTime.split(":")[1] === "00") {
        return true;
    } else {
        return false;
    }
};

const getIsOverlap = (tableData: any, payload: any, isUpdate: boolean) => {
    
    
    // let isDefaultRowExist = false;
    // let indexOfDefaultRow = -1;

    const { fromTime, toTime, id, isWeekend } = payload;

    const isMinuteZero = getIsMinuteZero({ fromTime, toTime });

    let checkisWeekend;
    if (isWeekend==='2') {
        checkisWeekend=true;
    }else{
        checkisWeekend=false;
    }

    /* Default Row without From time and to Time */

    // for (let i = 0; i < tableData.length; i++) {
    //     // console.log(tableData[i].isWeekend ,`${isWeekend}==>${checkisWeekend}`);
    //     if (!tableData[i].fromTime && !tableData.toTime && tableData[i].isWeekend==checkisWeekend) {
    //       isDefaultRowExist = true;
    //       indexOfDefaultRow = i;
    //     }
    // }

    if (fromTime && toTime && isMinuteZero && (getTimeInMilliSeconds(toTime) > getTimeInMilliSeconds(fromTime))) {
  
        let currentSlot = { fromTime: getTimeInMilliSeconds(fromTime), toTime: getTimeInMilliSeconds(toTime) };
  
        for (let i = 0; i < tableData.length; i++) {
            if(tableData[i].id !== id){
                console.log('created data',tableData[i].id)
                let currentBookedSlot = {
                    fromTime: getTimeInMilliSeconds( tableData[i].fromTime),
                    toTime:  getTimeInMilliSeconds( tableData[i].toTime)
                };
                if ((getOverlap(currentSlot, currentBookedSlot) > 0) && (tableData[i].isWeekend==checkisWeekend))
                {
                    alert("Time slot overlapped");
                    return true;
                }
            }else{
                console.log("update element",tableData[i].id);
                continue;
            }
        }
        
        return false;
    } 
    else if(fromTime === "" && toTime === "") {
        alert("FromTime And ToTime Require");
    }
     else if(fromTime && toTime && !isMinuteZero && !isUpdate) {
        alert("Minutes should be zero");
    } else {
        alert("Time entered are incorrect");
    }
};

export {getIsOverlap,getIsMinuteZero,getOverlap,extractToFromTimes};
